export class DIAppExpiry {
    public appUpdateURL!: string;
    public appExpiryDTTM!: string;
}
